import React, { useState, useEffect } from 'react';

// Components
import { FormButtons } from 'components-design-system'
import PrimeField from 'components/PrimeField/PrimeField';
import './preset-modal-content.scss'

const AddPreset = ({
  setOpenModal,
  presets,
  savePreset
}) => {
  const [presetName, setPresetName] = useState("");
  const [isInvalid, setInvalid] = useState(false);

  useEffect(() => {
    if (presetName) {
      let foundIndex = presets?.findIndex(preset => preset.name.toLowerCase() === presetName.toLowerCase());
      if (foundIndex !== -1) {
        setInvalid(true);
      } else {
        setInvalid(false);
      }
    }
  }, [presetName]);

  return <div className="preset-modal-content">
    <div className="modal-content">
      <PrimeField
        schema={{
          label: "Preset name",
          orientation: "vertical",
          type: "text",
          placeholder: "Enter preset name"
        }}
        showError={isInvalid}
        errorMessage={"A preset with that name already exists, please select a different name."}
        value={presetName}
        onChange={setPresetName} />
    </div>
    <div className="actions">
      <FormButtons
        size="large"
        onCancel={() => setOpenModal(false)}
        okText="Save"
        onOk={() => savePreset(presetName)}
        okButtonProps={{
          disabled: isInvalid,
        }}
      />
    </div>
  </div>
}

export default AddPreset